import { createContext, useContext, useEffect, useState } from "react"
import { useConfig } from "./ConfigProvider"
import { GetCrmEventTypes, CreateCRMEvent, GetCrmEvents, UpdateCRMEvent } from "../Services/CustomerService"
import { useAuth } from "./AuthProvider"
import { convertTextDateToDateObiect } from "../Helpers/ValidatorHelper"

const CrmContext = createContext()

export const useCrm = () => {
    return useContext(CrmContext)
}

const CrmProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const [crmEventTypes, setCrmEventTypes] = useState([])//wszystkie typy
    const [crmEventTypesForContractor, setCrmEventTypesForContractor] = useState([])//tylko takie które występują dla danego custId

    useEffect(() => {
        GetCrmEventTypes(api, null).then(res => {
            setCrmEventTypes(res.data)
        }).catch(e => {
            console.log(e)
            setCrmEventTypes([])
        })

        GetCrmEventTypes(api, authState.custId).then(res => {
            setCrmEventTypesForContractor(res.data)
        }).catch(e => {
            console.log(e)
            setCrmEventTypesForContractor([])
        })
    }, [authState.custId])

    const handleCreateCRMEvent = async (inputData) => {
        try {
            let formatedData = {
                custId: authState.custId,
                theme: inputData.topic,
                evaluation: inputData.grade,
                comments: inputData.note,
                eventDateTime: inputData.date,
                type: inputData.event,
            }
            let res = await CreateCRMEvent(api, formatedData)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleGetCrmEvents = async (pageNumber, pageSize, type, dateFrom, dateTo) => {
        if (authState.custId) {
            try {
                let res = await GetCrmEvents(api, authState.custId, pageNumber, pageSize, type, convertTextDateToDateObiect(dateFrom), convertTextDateToDateObiect(dateTo))
                return res.data
            } catch (error) {
                console.log(error)
                return []
            }
        }
    }

    const handleEditCrmEvent = async (recNo, type, theme, eventDateTime, evaluation, comments, name) => {
        try {
            let res = await UpdateCRMEvent(api, recNo, authState.custId, type, theme, convertTextDateToDateObiect(eventDateTime), evaluation, comments, name)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }


    return <CrmContext.Provider value={{
        crmEventTypes,
        crmEventTypesForContractor,
        handleCreateCRMEvent,
        handleGetCrmEvents,
        handleEditCrmEvent,
    }} >
        {children}
    </CrmContext.Provider>
}

export default CrmProvider